/**
 * @prettier
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Banner as ZolaBanner } from '@zola/zola-ui/src/components/Banner';

import Checklist from './Checklist';

import TipsIcon from '../../../../assets/images/doodles/tips.svg';

import styles from './styles.module.less';

const Banner = ({ onShowTips }) => {
  const tipsIcon = (
    <img className={styles.bannerTipsBtnIcon} src={TipsIcon} alt="Show card review tips" />
  );

  const tipsButton = (
    <div className={styles.bannerTipsBtn} onClick={() => onShowTips && onShowTips()}>
      {tipsIcon} Tips
    </div>
  );

  return (
    <div className={styles.bannerContainer}>
      <ZolaBanner type="warning">
        <div className={styles.bannerContents}>
          Make sure all text looks correct. Need help? {tipsButton}
        </div>
      </ZolaBanner>
    </div>
  );
};

Banner.propTypes = {
  onShowTips: PropTypes.func,
};

const Title = ({ children }) => {
  return (
    <div className={styles.title}>
      <h2>{children}</h2>
    </div>
  );
};

// TODO: Currently doesn't link to the front end back of the card.
const EditTextLinks = () => {
  return (
    <div className={styles.editLinks}>
      To edit any text, go back to the <b>front</b> or <b>back</b> of your card.
    </div>
  );
};

const Tips = () => {
  const alignIcon = (
    <span className={styles.alignIcon}>
      <i className="zolaicon zolaicon-text-align-left" />
    </span>
  );

  return (
    <Checklist.List>
      <Checklist.Item>
        <Checklist.Header>Double-check the spacing of your text.</Checklist.Header>
        <Checklist.Body>
          If you added extra spaces between words or letters, these will be removed when we print
          your cards.
        </Checklist.Body>
      </Checklist.Item>
      <Checklist.Item>
        <Checklist.Header>Make sure text is correctly aligned.</Checklist.Header>
        <Checklist.Body>
          To align text, use our handy alignment tool, {alignIcon}, not your spacebar or tabs key.
        </Checklist.Body>
      </Checklist.Item>
      <Checklist.Item>
        <Checklist.Header>Fix any overlapping text.</Checklist.Header>
        <Checklist.Body>
          Don’t forget to remove any unedited text boxes with default text (eg. “Add text”), too.
        </Checklist.Body>
      </Checklist.Item>
      <Checklist.Item>
        <Checklist.Header>Remove all special characters.</Checklist.Header>
        <Checklist.Body>
          Currently, we do not support non-Latin scripts or special characters (eg. accented
          letters).
        </Checklist.Body>
      </Checklist.Item>
    </Checklist.List>
  );
};

const Box = ({ children }) => {
  return <div className={styles.box}>{children}</div>;
};

export default { Banner, Title, EditTextLinks, Tips, Box };
